// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1ELFH","item":"PaymentsMobile_item__1DutK","label":"PaymentsMobile_label__2OBeb","amount":"PaymentsMobile_amount__1ISPg"};